// import { cn } from "~/lib/utils";
// import { ErrorProps, FormError } from ".";
// import { DropZone } from "../ui/dragzone";
// interface Props {
//   label: string;
//   required?: boolean;
//   errors?: ErrorProps;
//   onChange: (files: FileList | null) => void;
//   defaultValue: FileList | null;
//   value: FileList | null;
//   name: string;
// }
// export default function FormFilesDropzoneInput({
//   label,
//   required,
//   errors,
//   defaultValue,
//   onChange,
//   value,
//   name,
// }: Props) {
//   return (
//     <div>
//       <label className="space-y-1 capitalize">
//         <div
//           className={cn("text-base font-medium", {
//             "text-danger-500": errors?.error,
//           })}
//         >
//           {label} {required && <span className="text-danger-400">*</span>}
//         </div>
//         <DropZone
//           value={value}
//           name={name}
//           onChange={onChange}
//           defaultValue={defaultValue}
//         />
//         <FormError error={errors?.error} message={errors?.message} />
//       </label>
//     </div>
//   );
// }
import { Attachment } from "~/lib/types";
import { cn } from "~/lib/utils";

import { ErrorProps, FormError } from ".";
import { DropZone } from "../ui/dragzone";

interface Props {
  label: string;
  required?: boolean;
  errors?: ErrorProps;
  onChange: (files: FileList | null) => void; // Only files now
  onRemovedFiles?: (removedFiles: Attachment[]) => void; // Separate prop for removed files
  defaultValue: Attachment[] | FileList | null;
  value: Attachment[] | FileList | null;
  name: string;
}

export default function FormFilesDropzoneInput({
  label,
  required,
  errors,
  defaultValue,
  onChange,
  onRemovedFiles,
  value,
  name,
}: Props) {
  const handleDropzoneChange = (data: {
    files: FileList | null;
    removedFiles: Attachment[];
  }) => {
    // Handle files
    onChange(data.files);

    // Handle removed files if callback is provided — only fire when there are
    // actually removed files; uploading a new file should never trigger this.
    if (onRemovedFiles && data.removedFiles.length > 0) {
      onRemovedFiles(data.removedFiles);
    }
  };

  return (
    <div>
      <label className="space-y-1 capitalize">
        <div
          className={cn("text-base font-medium", {
            "text-danger-500": errors?.error,
          })}
        >
          {label} {required && <span className="text-danger-400">*</span>}
        </div>

        <DropZone
          value={value}
          name={name}
          onChange={handleDropzoneChange}
          defaultValue={defaultValue}
        />
        <FormError error={errors?.error} message={errors?.message} />
      </label>
    </div>
  );
}
